import { FlowPatientDataStoreEndpoint } from 'flow-schema';
import { type ComponentType } from 'react';
import type { z } from 'zod';

import { BookedAppointmentsVariant } from './variants/BookedAppointments';
import { ConditionsVariant } from './variants/Conditions';
import { DocumentMetadataVariant } from './variants/DocumentMetadata';
import { DocumentSearchVariant } from './variants/DocumentSearch';
import { DocumentTranscriptionsVariant } from './variants/DocumentTranscriptions';
import { EncountersVariant } from './variants/Encounters';
import { LabValuesVariant } from './variants/LabValues';
import { MedicationsVariant } from './variants/Medications';
import { OrdersVariant } from './variants/Orders';
import { PractitionersVariant } from './variants/Practitioners';
import { SurgicalHistoriesVariant } from './variants/SurgicalHistories';

interface PatientDataStoreVariant {
  schema: z.ZodObject<any>;
  Config: ComponentType;
}

export const PatientDataStoreVariants: Record<
  FlowPatientDataStoreEndpoint,
  PatientDataStoreVariant
> = {
  [FlowPatientDataStoreEndpoint.Practitioners]: PractitionersVariant,
  [FlowPatientDataStoreEndpoint.BookedAppointments]: BookedAppointmentsVariant,
  [FlowPatientDataStoreEndpoint.Conditions]: ConditionsVariant,
  [FlowPatientDataStoreEndpoint.Medications]: MedicationsVariant,
  [FlowPatientDataStoreEndpoint.SurgicalHistories]: SurgicalHistoriesVariant,
  [FlowPatientDataStoreEndpoint.Orders]: OrdersVariant,
  [FlowPatientDataStoreEndpoint.Encounters]: EncountersVariant,
  [FlowPatientDataStoreEndpoint.LabValues]: LabValuesVariant,
  [FlowPatientDataStoreEndpoint.DocumentMetadata]: DocumentMetadataVariant,
  [FlowPatientDataStoreEndpoint.DocumentSearch]: DocumentSearchVariant,
  [FlowPatientDataStoreEndpoint.DocumentTranscriptions]: DocumentTranscriptionsVariant,
};
